import { useMutation } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ApiError, api } from '../lib/api-client';

export function VerifyEmailPage() {
  const { token } = useParams<{ token: string }>();
  const triggered = useRef(false);

  const mutation = useMutation({
    mutationFn: () => api.post('/auth/verify-email', { token }),
  });

  useEffect(() => {
    if (!token || triggered.current) return;
    triggered.current = true;
    mutation.mutate();
  }, [token, mutation]);

  const err =
    mutation.error instanceof ApiError ? mutation.error.message : null;

  return (
    <div className="flex min-h-full items-center justify-center px-6 py-12">
      <div className="w-full max-w-sm rounded-2xl border border-slate-800 bg-slate-900/60 p-6 text-center shadow-xl">
        <h1 className="text-xl font-semibold">E-Mail-Bestätigung</h1>

        {!token && (
          <p className="mt-4 text-sm text-rose-300">
            Ungültiger Bestätigungs-Link.
          </p>
        )}
        {mutation.isPending && (
          <p className="mt-4 text-sm text-slate-300">Bestätige Deine E-Mail …</p>
        )}
        {mutation.isSuccess && (
          <>
            <p className="mt-4 text-sm text-emerald-300">
              E-Mail bestätigt. Du kannst Dich jetzt anmelden.
            </p>
            <Link
              to="/login"
              className="mt-6 inline-block rounded-lg bg-brand-600 px-4 py-2.5 text-base font-medium text-white hover:bg-brand-700"
            >
              Zum Login
            </Link>
          </>
        )}
        {err && (
          <>
            <p className="mt-4 text-sm text-rose-300">{err}</p>
            <p className="mt-2 text-xs text-slate-500">
              Bitte fordere einen neuen Bestätigungslink an oder kontaktiere
              den Admin.
            </p>
            <Link
              to="/login"
              className="mt-6 inline-block text-sm text-brand-400 hover:underline"
            >
              Zum Login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
